//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import BreadcrumbComponent from 'app_components/commons/breadcrumb';
import AlliancesLandingModule from 'app_components/modules/admin/landings/alliancesLanding';
import AppContainer from 'app_components/layouts/app'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../alliancesLandingScreen.scss'

// @ADD Component types
interface IAlliancesLandingScreenLayoutProps {}

const AlliancesLandingScreenLayout: React.FC<IAlliancesLandingScreenLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <AppContainer>
      <div className='alliances_landing_screen-layout'>
        <BreadcrumbComponent links={['/admin/landings', '#']} texts={[`${t('components.breadcrumb.landings')}`, `${t('components.breadcrumb.alliances_landing')}`]} />

        <div className="row">
          <div className="col-6">
            <AlliancesLandingModule />
          </div>
        </div>
      </div>
    </AppContainer>
  )
}

export default AlliancesLandingScreenLayout
